import {
  Create,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  Filter,
  List,
  Resource,
  SelectInput,
  Show,
  SimpleForm,
  TextField,
  TextInput
} from "react-admin";

const SECTION = [
  { id: 'Documents', name: 'Documents' },
  { id: 'Resources', name: 'Resources' },
]

const FEATURE = [
  { id: 'Library', name: 'Library' },
  { id: 'Compliance', name: 'Compliance' },
]

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="title" alwaysOn />
    <TextInput label="Section" source="section" />
    <TextInput label="Feature" source="feature" />
  </Filter>
);

const LibraryList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="title" label="Title" />
          <TextField source="section" label="Section" />
          <TextField source="cover" label="Cover URL" />
          <TextField source="feature" label="Feature" />
          <TextField source="url" label="Link URL" />
          <DateField source="createdAt" label="Creation date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowLibrary = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="title" label="Title" />
        <TextField source="section" label="Section" />
        <TextField source="cover" label="Cover URL" />
        <TextField source="feature" label="Feature" />
        <TextField source="url" label="Link URL" />
        <DateField source="createdAt" label="Creation date" />
        <EditButton />
      </SimpleForm>
    </Show>
  );
};

const CreateLibrary = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="title" label="Title" />
        <SelectInput source="section" label="Section" choices={SECTION} />
        <TextInput source="cover" label="Cover URL" />
        <SelectInput source="feature" label="Feature" choices={FEATURE} />
        <TextInput source="url" label="Link URL" />
      </SimpleForm>
    </Create>
  );
};

const EditLibrary = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="title" label="Title" />
        <SelectInput source="section" label="Section" choices={SECTION} />
        <TextInput source="cover" label="Cover URL" />
        <SelectInput source="feature" label="Feature" choices={FEATURE} />
        <TextInput source="url" label="Link URL" />
      </SimpleForm>
    </Edit>
  );
};



const libraryResource = () => <Resource
  name="library"
  options={{ label: 'Library - Compliance', menuGroup: 'Accounts' }}
  list={LibraryList}
  create={CreateLibrary}
  edit={EditLibrary}
  show={ShowLibrary} />;

export default libraryResource;